import React from 'react'
import styled from '@emotion/styled'

const StyledEditorDropzoneIndicatorCurtain = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: inherit;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  color: hsla(0, 0%, 80%, 1);
  font-size: 18px;
  font-weight: 500;
  pointer-events: none;
`
const StyledEditorDropzoneIndicatorContents = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 5px 65px;
  border: 4px dashed hsla(0, 0%, 94%, 1);
  width: 100%;
  height: 100%;
  border-radius: 10px;
  margin-top: -10px;
`

export default () => {
  return (
    <StyledEditorDropzoneIndicatorCurtain>
      <StyledEditorDropzoneIndicatorContents>
        Drop here to attach
      </StyledEditorDropzoneIndicatorContents>
    </StyledEditorDropzoneIndicatorCurtain>
  )
}
